import React, { useEffect, useCallback } from 'react';
import { ratingTypes } from '../../utils/constants';

import {
    Select,
    CheckBox,
} from '../Form';

const RatingChoiceFields = (props) => {
    const {
        hasTennisResults,
        ratingChoiceOptions,
        formApi,
    } = props;

    const { values, setValue, reset } = formApi;

    const disablePickleballSelection = hasTennisResults && values.ratingChoice === 'ProgressionBallRating';

    useEffect(() => {
        if (hasTennisResults) {
            if (values.ratingChoice === 'ProgressionBallRating') {
                setValue('showPickleballRating', false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeRatingChoice = useCallback((value) => {
        if (hasTennisResults) {
            if (value === 'ProgressionBallRating') {
                setValue('showPickleballRating', false);
            } else if (values.ratingChoice === 'ProgressionBallRating') {
                reset('showPickleballRating');
            }
        }
    }, [hasTennisResults, setValue, reset, values]);

    useEffect(() => {
        const fieldsToCheck = ['showTennisRating', 'showPickleballRating'];

        const isAtLeastOneDisplayRatingEnabled = fieldsToCheck.reduce((acc, curVal) => {
            return values[curVal] || acc;
        }, false);

        if (!isAtLeastOneDisplayRatingEnabled) {
            setTimeout(() => {
                setValue('showTennisRating', true);
            }, 500);
        }
    }, [values, setValue]);

    return (
        <div className="form-group from-group-xl">
            <label className="mb8">
                Your ratings
            </label>
            <CheckBox
                id="showTennisRating"
                field="showTennisRating"
                customLabel={`Display my ${ratingTypes.tennis} (tennis)`}
                formGroupCssClass="mb8"
                disabled={hasTennisResults}
                data-testid="profile-edit.ratings.tennis-checkbox"
            />
            <Select
                label="Select the rating you'd like to display"
                id="ratingChoice"
                field="ratingChoice"
                options={ratingChoiceOptions}
                attributeToSave="value"
                formGroupCssClass="ml24 mb8"
                onChange={onChangeRatingChoice}
            />
            <CheckBox
                id="showPickleballRating"
                field="showPickleballRating"
                customLabel={`Display my ${ratingTypes.pickleball} (pickleball)`}
                formGroupCssClass="mb8"
                disabled={disablePickleballSelection}
                data-testid="profile-edit.ratings.pickleball-checkbox"
            />
        </div>
    );
};

export default RatingChoiceFields;
